import { Button, ButtonProps } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { useState } from 'react';

interface ConfirmationDialogProps {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  children: React.ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  isCancel?: boolean;
  slots?: {
    confirmButton?: ButtonProps;
    cancelButton?: ButtonProps;
  };
}

const ConfirmationDialog = ({
  title = '',
  message = '',
  confirmText = 'Yes',
  cancelText = 'Cancel',
  onConfirm = () => {},
  onCancel = () => {},
  isCancel = true,
  slots,
  children,
}: ConfirmationDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          {isCancel && (
            <DialogClose asChild>
              <Button
                onClick={onCancel}
                variant={'secondary'}
                {...slots?.cancelButton}
              >
                {cancelText}
              </Button>
            </DialogClose>
          )}
          <DialogClose asChild>
            <Button onClick={onConfirm} {...slots?.confirmButton}>
              {confirmText}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
